<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" lg="5" xl="5">
        <v-timeline dense>
          <v-timeline-item
            v-for="experience in experiences"
            :key="`${experience.company}-${experience.title}`"
            :fill-dot="experience.isCurrentPosition"
            :large="experience.isCurrentPosition"
            right
            color="custom"
          >
            <template v-slot:icon>
              <v-avatar>
                <img :src="require(`@/assets/img/experience/${experience.iconFileName}`)">
              </v-avatar>
            </template>
            <div>
            <v-card class="elevation-2">
              <v-card-title class="larger-text-sizing font-weight-bold text-break-word">
                {{ experience.company }}
              </v-card-title>
              <v-card-text class="standard-text-sizing text-break-word mb-3">
                <p>{{ experience.title }}</p>
                <p>{{ experience.date }}</p>
              </v-card-text>
            </v-card>
            </div>
            <div class="card-descriptor-tag px-5">
              <div class="card-descriptor-tag-content white--text">
                <v-btn block dark small class="standard-text-sizing" @click="viewExperience(experience.id)">
                  <span>View More</span>
                  <font-awesome-icon :icon="['fas', 'arrow-right']" size="xs" class="ml-1"/>
                </v-btn>
              </div>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import experiences from '@/data/experiences';

  export default {
    name: 'Experience',
    data: () => ({
        experiences: experiences
    }),
    methods: {
      viewExperience(a) {
        this.$router.push({ name: 'Experience', params: { id: a }})
      }
    }
  }
</script>

<style lang="scss">
@import 'src/assets/scss/global.scss';

.v-timeline-item__inner-dot {
  background-color: $router-link-colour__active !important;
}

</style>

